import { ArrowLeft } from "lucide-react"

interface ScanNavbarProps {
  onBack?: () => void
  title?: string
  subtitle?: string
}

/** Top bar for the palm scan flow — back arrow and optional centered title. */
export function ScanNavbar({ onBack, title, subtitle }: ScanNavbarProps) {
  return (
    <div className="relative flex h-14 w-full shrink-0 items-center px-4">
      {onBack ? (
        <button
          type="button"
          onClick={onBack}
          aria-label="Go back"
          className="absolute left-4 flex size-10 items-center justify-center text-purple-light"
        >
          <ArrowLeft className="size-6" />
        </button>
      ) : null}

      {title ? (
        <div className="mx-auto flex max-w-[298px] flex-col items-center text-center">
          <p className="font-body text-base font-semibold text-purple-light">{title}</p>
          {subtitle ? (
            <p className="truncate font-body text-xs text-purple-light/70">{subtitle}</p>
          ) : null}
        </div>
      ) : null}
    </div>
  )
}
